export enum BrandKitCreationRoute {
  LOGO = 'logo',
  DESIGN = 'design',
  WEBSITE = 'website',
  SCRATCH = 'scratch',
}

export enum BrandKitCreationTileVisualType {
  ICON = 'icon',
  DESIGN_DUO = 'design-duo',
}

interface BrandKitCreationIconVisual {
  type: BrandKitCreationTileVisualType.ICON;
  icon: string;
}

/** The two fanned-out sample designs the AI prompt box also uses, standing in for an icon. */
interface BrandKitCreationDesignDuoVisual {
  type: BrandKitCreationTileVisualType.DESIGN_DUO;
  assetPath: string;
}

export type BrandKitCreationTileVisual = BrandKitCreationIconVisual | BrandKitCreationDesignDuoVisual;

export interface BrandKitCreationTileSpec {
  route: BrandKitCreationRoute;
  visual: BrandKitCreationTileVisual;
  titleKey: string;
  /** The shorter title the mobile tiles use, where there is no room for the subtitle either. */
  mobileTitleKey: string;
  subtitleKey: string;
  isRecommended?: boolean;
}

export const BRAND_KIT_CREATION_TILES: BrandKitCreationTileSpec[] = [
  {
    route: BrandKitCreationRoute.LOGO,
    visual: {type: BrandKitCreationTileVisualType.ICON, icon: 'icon-logo'},
    titleKey: 'pmwjs_start_with_your_logo',
    mobileTitleKey: 'pmwjs_start_with_logo',
    subtitleKey: 'pmwjs_well_auto_fetch_colors_and_fonts',
    isRecommended: true,
  },
  {
    route: BrandKitCreationRoute.DESIGN,
    visual: {type: BrandKitCreationTileVisualType.DESIGN_DUO, assetPath: 'ai-prompt-box-templates.webp'},
    titleKey: 'pmwjs_start_with_your_design',
    mobileTitleKey: 'pmwjs_start_with_design',
    subtitleKey: 'pmwjs_well_auto_fetch_brand_assets',
  },
  {
    route: BrandKitCreationRoute.WEBSITE,
    visual: {type: BrandKitCreationTileVisualType.ICON, icon: 'icon-globe'},
    titleKey: 'pmwjs_start_with_your_website',
    mobileTitleKey: 'pmwjs_start_with_website',
    subtitleKey: 'pmwjs_well_auto_fetch_brand_assets',
  },
  {
    route: BrandKitCreationRoute.SCRATCH,
    visual: {type: BrandKitCreationTileVisualType.ICON, icon: 'icon-pencil'},
    titleKey: 'pmwjs_start_from_scratch',
    mobileTitleKey: 'pmwjs_start_from_scratch',
    subtitleKey: 'pmwjs_add_your_brand_assets_manually',
  },
];

/**
 * The one-click branding loop shown beside the tiles. Its first frame is nothing but its blue-purple
 * backdrop, which the slot's CSS gradient reproduces, so no poster image is needed while it loads.
 */
export const BRAND_KIT_INTRO_VIDEO_PATH = 'brand-kit-one-click-promo.mp4';

export interface BrandKitCreationEmptyStateProps {
  onSelectRoute: (route: BrandKitCreationRoute) => void;
  /** A user without access still sees this, with a crown; any CTA opens the upsell instead. */
  isGated?: boolean;
}
